import { useEffect, useState } from "react";
import * as Parse from "papaparse";
import SplineApi from "../../tools/spline-api";
import { useAuth0 } from "@auth0/auth0-react";

export default function useUSTreasuryRawData(parserConfig = {}) {
  const [rawData, setRawData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  
  const load = async function () {
    const token = await getAccessTokenSilently()
    const api = new SplineApi(token)
    try {
      setLoading(true);
      const csv = await api.getTreasuryData()
      setRawData(Parse.parse(csv, parserConfig).data);
    } catch (error) {}
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  return { rawData, loading };
}
